import type { HomeMeeting, HomeTask, HomeStatItem } from "./types";
import { inferTaskBucket } from "./workloadMatrix";

/** Derive headline stats from the current task queue and meetings. */
export function buildHomeStats(
  tasks: HomeTask[],
  meetings: HomeMeeting[] = [],
): HomeStatItem[] {
  const active = tasks.filter((task) => !task.completed);

  return [
    {
      id: "due",
      label: "Due",
      value: active.filter((task) => inferTaskBucket(task) === "due").length,
      tone: "due",
    },
    {
      id: "chasing",
      label: "Chasing",
      value: active.filter((task) => inferTaskBucket(task) === "chasing").length,
      tone: "chasing",
    },
    {
      id: "stale",
      label: "Stale",
      value: active.filter((task) => inferTaskBucket(task) === "stale").length,
      tone: "stale",
    },
    {
      id: "booked",
      label: "Booked",
      value: meetings.filter((meeting) => meeting.assignedToMe).length,
      tone: "booked",
    },
  ];
}
